import { MARQUEE_ITEMS } from '../data/content';

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="overflow-hidden border-y border-brand-grey bg-white py-5" aria-hidden="true" data-testid="editorial-marquee">
      <div className="marquee-track items-center gap-10 pr-10">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-heading text-sm font-semibold uppercase tracking-[0.3em] text-brand-black/70">{item}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-brand-green" />
          </span>
        ))}
      </div>
    </div>
  );
}
